export const AUDIT_LOG_OWNER_TYPE = {
  RULE: "Rule",
  USER: "User",
} as const;
